<template>
  <div class="maintenance-container">
    <AttensiCard class="maintenance-box">
      <div class="maintenance-box__content">
        <Icon :type="'no-data-trond'" />
        <h2>Maintenance Break</h2>
        <p>We're taking a maintenance break! Insights will be back shortly</p>
        <p>
          Please see
          <a href="https://status.attensi.com/posts/dashboard" target="_blank">
            status.attensi.com
          </a>
          for the latest updates
        </p>
      </div>
    </AttensiCard>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { AttensiCard } from '@attensi/materia'
import Icon from '@/components/Icons'

export default {
  components: {
    AttensiCard,
    Icon,
  },
  setup() {
    const isMaintenanceMode = ref(true)
    const message = ref("We're making improvements. Please check back soon.")
    const endTime = ref(Date.now() + 1000 * 60 * 30) // 30 minutes from now

    const remainingTime = computed(() =>
      Math.max(0, endTime.value - Date.now())
    )

    const formattedTime = computed(() => {
      const minutes = Math.floor(remainingTime.value / 1000 / 60)
      const seconds = Math.floor((remainingTime.value / 1000) % 60)
      return `${minutes}m ${seconds}s`
    })

    const disableMaintenance = () => {
      isMaintenanceMode.value = false
    }

    onMounted(() => {
      setInterval(() => {
        remainingTime.value
      }, 1000)
    })

    return {
      isMaintenanceMode,
      message,
      formattedTime,
      remainingTime,
      disableMaintenance,
    }
  },
}
</script>

<style scoped lang="scss">
.maintenance-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.maintenance-box {
  width: 800px;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  background-color: var(--color-white);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;

    p {
      font-size: 1.5rem;
      text-align: center;
    }
  }
}
</style>
